var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"150px","padding-left":"50px","border-bottom":"10px solid #1d1d63","font-weight":"bold","width":"100%"}},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }